module.exports = __webpack_public_path__ + "img/Frente-73-02 open.8dd698be.jpg";